export default __webpack_public_path__ + "static/media/Black-Arrangement.20f044dd.svg";